var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"circle":_vm.circle},on:{"view-another-circle":_vm.anotherCircle,"update-circle":_vm.updateCircle,"remove-mod":_vm.removeMod,"add-mod":_vm.addMod}})}
var staticRenderFns = []

export { render, staticRenderFns }